import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button } from "reactstrap";
// import "./datatables.scss";
import '../Icons/IconFontawesome';

import Utils from '../Utility';
import { post, get, put } from "../../helpers/api_helper";
import Modal from './DeleteModal';
import DataTable from 'react-data-table-component';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from 'react-toastify';

const UnassignedLeads = (props) => {
  const { user, role, setCurrentLead, setIsAddForm } = props;
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [moderator, setModerators] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [modalData, setModalData] = useState({ type: "Delete" });
  // console.log('props on card on lead', props);

  useEffect(() => {
    if (user?.companyId) {
      getLeads();
    }
  }, [user]);

  useEffect(() => {
    setColumns([
      {
        name: 'Lead Name',
        selector: row => row.name,
      },
      {
        name: 'Client Email',
        selector: row => row.email,
      },
      {
        name: 'Client Mobile',
        selector: row => row.mobile,
      },
      {
        name: 'Description',
        selector: row => row.intro.length > 30 ? row.intro.substring(0, 30) + '...' : row.intro,
      },
      {
        cell: (row) => <>
          <AvForm style={{}}>
            <div style={{position:'absolute', left:35}}>
              <AvField onChange={(e) => handleUpdateStatus(row, e.target.value)} style={{ minWidth: 150, padding: 5, paddingLeft: 8, paddingRight: 8 }}
                type="select"
                name="status"
                placeholder={"Select Status"}
                value={row?.status}
              >
                <option value="">Select Status</option>
                <option value={"Open"}>Open</option>
                <option value={"In Process"}>In Process</option>
                <option value={"Rejected"}>Rejected</option>
                <option value={"Closed"}>Closed</option>
              </AvField>
            </div>
          </AvForm>
          {/* <Button onClick={() => handleDeleteUser(row)} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-cancel" style={{ fontSize: 20 }}></span></Button> */}
        </>,
        name: 'Status',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
      {
        cell: (row) => <>
          <Button onClick={() => openLead(row)}
            title={"Details"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-eye" style={{ fontSize: 20 }}></span></Button>
          {row?.addedBy == user?._id ?
            <Button onClick={() => handleUpdateLead(row)}
              title={"Archive"}
              style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
            : null
          }
        </>,
        name: 'Action',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ])
  }, [data]);

  const getLeads = async () => {
    get("/lead/list/dealer", { token: user?.token })
      .then(json => {
        // console.log('response from get lead list', json);
        setData(json?.data);
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  }

  const handleUpdateStatus = (lead, status) => {
    console.log('updating lead', lead);
    setModalData({ type: "Status", leadName: lead?.name, leadId: lead?._id, status:status });
    setIsModal(true);
  }

  const handleUpdateLead = (item) => {
    setCurrentLead(item);
    setIsAddForm(true);
  }

  const onConfirm = () => {
    let body = {};
    if (modalData?.type == 'Assign') {
      if (user?.role == "Admin")
        body = { lead_id: modalData?.leadId, assignToM: modalData?.userId, token: user?.token };
      else
        body = { lead_id: modalData?.leadId, assignToD: modalData?.userId, token: user?.token };
    } else if (modalData?.type == 'Archive') {
      body = { lead_id: modalData?.leadId, status: 'Archived', token: user?.token };
    }
    else if(modalData?.type=='Status'){
      body = { lead_id: modalData?.leadId, status: modalData?.status, token: user?.token };
    }
    put("/lead/update", body)
      .then(json => {
        console.log('response from delete user', json);
        if (json.statusCode == 200) {
          toast.success("Success");
          getLeads();
          setIsModal(false);
          setModalData({ type: "Delete" });
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  const openLead=(lead)=>{
      props.history.push('/lead/'+lead?._id);
  }

  return (
    <React.Fragment>
      <div className="">
        <Modal
          show={isModal}
          onClick={() => onConfirm()}
          onCloseClick={() => setIsModal(false)}
          data={modalData}
        />
        <DataTable
          columns={columns}
          data={data}
          pagination
          customStyles={{
            headCells: {
              style: {
                color: 'black',
                fontWeight: 'bold',
                fontSize: 15,
                // maxWidth: 80
              },
            },
            // cells: {
            //   style: {
            //     maxWidth: 50
            //   }
            // }
          }}
        />
      </div>
    </React.Fragment>
  )
}

export default UnassignedLeads;
